export default function getKeyName(appName: string, suffix: string) {
    return appName + '_' + suffix;
}
